import { createContext } from 'react';
export const defaultWellContext = {
  WellItemComponent: 'div'
};
const WellContext = /*#__PURE__*/createContext(defaultWellContext);
export const {
  Consumer: WellContextConsumer,
  Provider: WellContextProvider
} = WellContext;